import { Subject } from 'rxjs';

export class IntralinksContentContainerConfig {
    actionSubject$: Subject<IntralinksContentContainerAction>;
    // feedbackSubject$: Subject<IntralinksGroupReadyFeedback>;
    constructor() {
        this.actionSubject$ = new Subject<IntralinksContentContainerAction>();
    }
}

export class IntralinksContentContainerAction {
    type: IntralinksContentContainerActionType;
    payload: any;
}

export enum IntralinksContentContainerActionType {
    RELOAD = 'RELOAD'
}

export enum IntralinksContentType {
    GROUP = 'GROUP',
    FOLDER = 'FOLDER',
    LOADING = 'LOADING',
    EMPTY = 'EMPTY'
}

export class IntralinksContentContainerReloadActionPayload {
    constructor(public contentType: IntralinksContentType, public config: any) {
    }
}

export class IntralinksContentContainerReloadAction implements IntralinksContentContainerAction {
    type = IntralinksContentContainerActionType.RELOAD;
    constructor(public screenId: string, public workspaceId: string, public payload: IntralinksContentContainerReloadActionPayload, public workspaceIds?: string[]) {
    }
}
